import { Icon } from '@components';
import { routes } from '@constants';
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import CertificateSmall from '@pngs/certificate.png';
import { Flex, Image, theme, Typography } from '@styles';
import { ReactComponent as Settings } from '@svgs/settings.svg';
import { string } from 'prop-types';
import React from 'react';

import {
  getCertificateContentContainerStyles,
  getCertificateImageStyles,
  getCertificateInfoContainerStyles,
  styles,
} from './CertificateInfo.styles';

const CertificateInfo = ({ date, title }) => {
  const { isTabletSM } = useScreenSize();

  const { navigate } = useNavigateWithOfflineMode();

  const handleSettingsButtonClick = () =>
    navigate(routes.certificateSettings, { state: { date, title } });

  return (
    <Flex {...getCertificateInfoContainerStyles({ isTabletSM })}>
      <Image
        src={CertificateSmall}
        {...getCertificateImageStyles({ isTabletSM })}
      />
      <Flex {...getCertificateContentContainerStyles({ isTabletSM })}>
        <Flex flexDirection="column" py={24}>
          <Typography
            color={theme.colors.white[100]}
            opacity="0.7"
            variant="MS-semibold-s16-lh25"
          >
            {date}
          </Typography>
          <Typography
            color={theme.colors.white[100]}
            marginTop="8px"
            variant="MS-bold-s20-lh21"
          >
            {title}
          </Typography>
        </Flex>
        <Flex>
          <Icon
            height={40}
            onClick={handleSettingsButtonClick}
            style={styles.settingsIcon}
            SVG={Settings}
            width={40}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

CertificateInfo.propTypes = {
  date: string.isRequired,
  title: string.isRequired,
};

export default CertificateInfo;
